import { DialogService } from '@sdbn/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { ContextChange, DashboardContext, WidgetReference } from '@sdbn/common';

import { TranslationService } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/common';
import { CarrierCleanupQuery, CarrierCleanupQueryResult, CarrierListEntry, CarrierReplacement } from '../cleanup-administration.model';
import { CleanupAdministrationService } from '../cleanup-administration.service';
import { AbstractWidgetComponent } from '@sdbn/common';

@Component({
    selector: 'app-cleanup-administration',
    templateUrl: './cleanup-administration.component.html',
    styleUrls: ['./cleanup-administration.component.scss'],
    standalone: false
})
export class CleanuupAdministrationComponent extends AbstractWidgetComponent {

  reference: WidgetReference;
  context: DashboardContext;

  carriersToReplace = new Array<CarrierListEntry>();
  carrierListEntries = new Array<CarrierListEntry>();
  dataSource: MatTableDataSource<CarrierListEntry> = new MatTableDataSource(new Array<CarrierListEntry>());

  responseMessages: ResponseMessage[];

  loading = false;

  carrierQueryFormGroup = new FormGroup({
    query: new FormControl('', [Validators.required, Validators.minLength(1)])
  });
  carrierQueryValid = false;

  carrierReplacementFormGroup = new FormGroup({
    replacement: new FormControl('', [Validators.required, Validators.minLength(1)])
  });
  replaceButtonEnabled = false;

  // @ViewChild(MatSort) sort: MatSort;
  sortDirection = 'asc';
  sortColumn = 'carrier';
  columnsToDisplay = [
    'checkbox', 'carrier', 'count'
  ];

  constructor(
    public translationService: TranslationService,
    private dialog: MatDialog,
    private cleanupAdministrationService: CleanupAdministrationService,
    private dialogService: DialogService
  ) {
    super();
    this.carrierQueryFormGroup.valueChanges.subscribe(
      value => {
        if (this.carrierQueryFormGroup.dirty) {
          this.carrierQueryValid = this.carrierQueryFormGroup.valid;
        }
      }
    );

    this.carrierReplacementFormGroup.valueChanges.subscribe(
      value => {
        if (this.carrierReplacementFormGroup.dirty) {
          this.updateReplacementButtonEnabledment();
        }
      }
    );
  }

  private updateReplacementButtonEnabledment() {
    this.replaceButtonEnabled = this.carrierReplacementFormGroup.valid && this.carriersToReplace.length > 0;
  }

  public carrierSelectionChanged(carrier: CarrierListEntry) {
    carrier.selected = !carrier.selected;
    this.carriersToReplace = this.carrierListEntries.filter(c => carrier.selected);
    this.updateReplacementButtonEnabledment();
  }

  public findCarriersByQuery() {
    this.loading = true;
    this.carrierListEntries = new Array<CarrierListEntry>();
    this.carriersToReplace = new Array<CarrierListEntry>();
    this.dataSource.data = [];

    const query = new CarrierCleanupQuery();
    query.queryString = this.carrierQueryFormGroup.controls.query.value;
    this.cleanupAdministrationService.findCarrierByQuery(query).subscribe(
      result => {
        result.forEach(
          r => {
            this.carrierListEntries.push(new CarrierListEntry(r));
          }
        );
        this.dataSource.data = this.carrierListEntries;
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  }

  public findAndReplace() {

    let countToReplace = 0;

    this.carriersToReplace.forEach(c => countToReplace += c.count);

    //  messageParams: [countToReplace, this.carrierReplacementFormGroup.controls.replacement.value],
    const title = this.translationService.translate('tmc-yard.ui.admin.cleanup-administration.find-and-replace.confirm-dialog.title');
    let description = this.translationService.translate('tmc-yard.ui.admin.cleanup-administration.find-and-replace.confirm-dialog.message');

    description = description.replace('{0}', countToReplace.toString());
    description = description.replace('{1}', this.carrierReplacementFormGroup.controls.replacement.value);

    this.dialogService.showConfirmWithTitleAndMessage(title, description).afterClosed().subscribe(result => {
      if (result) {
        this.loading = true;

        const replacement = new CarrierReplacement();
        replacement.replacement = this.carrierReplacementFormGroup.controls.replacement.value;

        this.carriersToReplace.forEach(
          c => {
            if (c.selected) {
              replacement.carriersToReplace.push(new CarrierCleanupQueryResult(c));
            }
          }
        );
        this.cleanupAdministrationService.replaceCarriers(replacement).subscribe(
          result => {
            this.findCarriersByQuery();
          },
          error => {
            this.loading = false;
          }
        );
      }
    });
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }
}
